import api from './api'

export default {
  async listarVendas(params = {}) {
    const paramsComEmpresa = { ...params, empresaId: 3 }
    const response = await api.get('/vendas', { params: paramsComEmpresa })
    return response.data
  },

  async buscarVenda(id) {
    const response = await api.get(`/vendas/${id}`, { params: { empresaId: 3 } })
    return response.data
  },

  async criarVenda(dados) {
    const dadosComEmpresa = { ...dados, empresaId: 3 }
    const response = await api.post('/vendas', dadosComEmpresa)
    return response.data
  },

  async criarCheckout(vendaId, dadosCliente = null) {
    const body = dadosCliente ? {
      clienteId: dadosCliente.clienteId,
      clienteNome: dadosCliente.nome,
      clienteEmail: dadosCliente.email,
      clienteTelefone: dadosCliente.telefone
    } : null

    const response = await api.post(`/vendas/${vendaId}/checkout`, body)
    return response.data
  },

  async consultarStatusPagamento(vendaId) {
    const response = await api.get(`/vendas/${vendaId}/status-pagamento`, {
      params: { empresaId: 3 }
    })
    return response.data
  },

  async validarProdutosParaVenda(produtoIds) {
    const response = await api.get('/vendas/validar-vendas-produtos', {
      params: { produtoIds: produtoIds.join(',') }
    })
    return response.data
  },

  async verificarPlanoFunerario(produtoIds) {
    const response = await api.get('/vendas/verificar-plano-funerario', {
      params: { produtoIds: produtoIds.join(',') }
    })
    return response.data
  },

  async verificarDetalhesProdutos(produtoIds) {
    const response = await api.get('/vendas/verificar-detalhes-produtos', {
      params: { produtoIds: produtoIds.join(',') }
    })
    return response.data
  },

  async atualizarStatusVenda(vendaId, statusVenda) {
    const response = await api.put(`/vendas/${vendaId}/status-venda`, {
      statusVenda: statusVenda
    })
    return response.data
  }
}

